<button class="button" type="button">
  @if (icon()) {
    <app-icon [name]="icon()" [size]="'xl'" class="button__icon" />
  }
  <p>{{ text() }}</p>
</button>
